<template>
    <div class="gcmcn-card-gradient entity-details">
        <div class="" v-separator-link="200">
            <div class="feed-details-container gcmcn-card">
                <div class="feed-details">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="details-title">Channel Name</div>
                            <p>{{channel.display_name}}</p>
                        </el-col>
                        <el-col  :span="12">
                            <el-button
                                type="primary"
                                class="gcmcn-primary-btn small"
                                :loading="loading"
                                :disabled="channel.status ==='FINISHED'"
                                @click="editChannel"
                                :gutter="10"
                            >
                                Edit
                            </el-button>
                            <el-button
                                type="warning"
                                class="gcmcn-warning-btn small"
                                v-if="showEditButton"
                                :disabled="disableEditInputButton"
                                :loading="loading"
                                @click="editOtherFields()"
                                style="margin-right: 10px;"
                            >
                                Edit Input
                            </el-button>
                            <el-popover
                                ref="popover-stop-channel"
                                placement="bottom"
                                width="142"
                                :trigger="'click'"
                                popper-class="dark-popper"
                                content="Are you sure ? Stopping the channel will stop the current scheduling
    "
                            >
                                <div class="popover-title">Confirm channel stop</div>
                                <div
                                    class="popover-content"
                                    style="word-break: break-word"
                                >
                                    Are you sure ? Stopping the channel will stop the current scheduling
                                </div>
                                <div class="actions">
                                    <el-button type="text" class="decline" @click="hidePopoverStopChannel()">No</el-button>
                                    <el-button type="text" class="accept" @click="stopChannel()">Yes</el-button>
                                </div>
                                <el-button
                                    v-if="showStopButton"
                                    slot="reference"
                                    type="danger"
                                    :disabled="disableStopButton"
                                    :loading="loading"
                                    class="gcmcn-danger-btn small"
                                    @click="popOverOpened = true"
                                >
                                    Stop
                                </el-button>
                            </el-popover>
                            <el-tooltip
                                :disabled="!disableDeleteButton"
                                class="item"
                                effect="dark"
                                content="You can't delete a channel if takers have rights"
                                placement="bottom"
                            >
                                <span>
                                    <el-button
                                        v-if="showDeleteButton &&
                                        (userIsAtLeastAdmin || userIsEntityAdmin(entityUid))"
                                        type="danger"
                                        class="gcmcn-danger-btn small"
                                        :disabled="disableDeleteButton"
                                        :loading="loading"
                                        @click="dialogVisible = true;"
                                    >
                                        Delete
                                    </el-button>
                                </span>
                            </el-tooltip>
                            <el-dialog
                                title="Confirm channel deletion"
                                :visible.sync="dialogVisible"
                                width="40%"
                                custom-class="modal-confirm-channel-deletion"
                                :modal-append-to-body="false"
                            >
                                <div v-if="channel.confirmed">
                                    <div
                                        class="confirmed-channel-deletion"
                                        style="word-break: break-word"
                                    >
                                        Channel resources will be deleted if you confirm this action.
                                        Please type the <span style="display: inline-block;">"{{channel.display_name}}"</span> to delete channel :
                                        <el-input
                                            v-model="confirmChannelDeletionValue"
                                            class="gcmcn-form-input confirm-input"
                                        ></el-input>
                                    </div>
                                    <div
                                        class="actions"
                                    >
                                        <el-button type="text" class="decline" @click="hideDeleteModal()">No</el-button>
                                        <el-button
                                            v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                                            type="text"
                                            class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                                            :disabled="checkChannelDeletionConfirmation"
                                            @click="deleteChannel()"
                                        >
                                            Delete
                                        </el-button>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="actions"
                                >
                                    <el-button type="text" class="decline" @click="hideDeleteModal()">No</el-button>
                                    <el-button
                                        type="text"
                                        class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                                        @click="deleteChannel()"
                                    >
                                        Yes
                                    </el-button>
                                </div>
                            </el-dialog>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <div class="details-title">Description</div>
                            <p>{{channel.description}}</p>
                        </el-col>
                        <el-row :gutter="20">
                            <el-col :span="11" class="padding-left">
                                <div class="details-title">Universe</div>
                                <p>{{ universe ? universe.display_name : '' }}</p>
                            </el-col>
                            <el-col :span="11">
                                <div class="details-title">Event</div>
                                <p>{{ event.name }}</p>
                            </el-col>
                        </el-row>
                        <div
                            v-if="channel.confirmed &&
                            (userIsAtLeastAdmin || userIsEntityAdmin(entityUid))"
                        >
                            <el-col :span="24">
                                <div class="details-title">Main IP</div>
                                <p>{{ videoSourceMainDetails }}</p>
                            </el-col>
                            <el-col :span="24">
                                <div class="details-title">Backup IP</div>
                                <p>{{ videoSourceBackupDetails }}</p>
                            </el-col>
                        </div>

                        <el-col
                            v-if="channel.confirmed &&
                                (userIsAtLeastAdmin || userIsEntityAdmin(entityUid))
                            && videoSource"
                            :span="16"
                        >
                            <div class="details-title">Globecast region</div>
                            <p>{{ videoSource.datacenter }}</p>
                        </el-col>
                        <el-col :span="16">
                            <div class="details-title">Status</div>
                            <p>{{channel.status}}</p>
                        </el-col>
                        <el-col :span="24">
                            <div class="details-title">Is blankable</div>
                            <p>{{channel.is_blankable}}</p>
                        </el-col>
                        <el-col :span="24" v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)">
                            <div class="details-title">Thumbnail generation enabled</div>
                            <p>{{channel.enable_thumbnail_generation}}</p>
                        </el-col>
                        <el-col :span="24">
                            <div class="details-title">Channel ID</div>
                            <p>{{channel.channel_identifier}}</p>
                        </el-col>
                        <el-col :span="24">
                            <div class="details-title">Overview page number</div>
                            <p v-if="channel.overview_page_number === 0">
                                N/A
                            </p>
                            <p v-else>{{channel.overview_page_number}}</p>
                        </el-col>
                        <el-col :span="24">
                            <div class="details-title">Overview page position</div>
                            <p v-if="channel.overview_page_position === 0">
                                N/A
                            </p>
                            <p v-else>{{channel.overview_page_position}}</p>
                        </el-col>
                        <el-col :span="24">
                            <div class="details-title">Duration</div>
                            <p>{{defaultDuration}}</p>
                        </el-col>
                        <el-col :span="8">
                            <div class="details-title">Default start time</div>
                            <p>{{startTimeUTC}} <small class="timezone-label">UTC 0</small></p>
                            <p>{{startTimeLocal}} <small class="timezone-label">LOCAL TIME</small></p>
                        </el-col>
                        <el-col :span="8">
                            <div class="details-title">Default end time</div>
                            <p>{{endTimeUtc}} <small class="timezone-label">UTC 0</small></p>
                            <p>{{endTimeLocal}} <small class="timezone-label">LOCAL TIME</small></p>
                        </el-col>
                        <el-col :span="8">
                            <el-button
                                type="warning"
                                class="gcmcn-warning-btn small"
                                v-if="showEditButton"
                                :disabled="disableEditTimesButton"
                                :loading="loading"
                                @click="editTimeFields()"
                            >
                                Edit default time
                            </el-button>
                        </el-col>
                        <el-col :span="24">
                            <el-button
                                type="warning"
                                class="gcmcn-warning-btn small"
                                v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                                :disabled="disableConfirmButton"
                                :loading="loading"
                                @click="confirmChannel"
                            >
                                Book Channel
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- Booking modal -->
        <modal-confirm-channel
            ref="modal-confirm-channel"
            @watch-channel-modification-request="watchChannelModificationRequest"
            @on-trigger-refresh="onTriggerRefresh"
        ></modal-confirm-channel>
    </div>
</template>

<script>
    import moment from 'moment';
    import ModalConfirmChannel from './modal-confirm-channel.vue';
    import { mapGetters } from 'vuex';
    export default{
        name: 'channels-details',
        components: {
            ModalConfirmChannel,
        },
        props:{
            channel:{
                type: Object,
                required: true,
            },
            event:{
                Type: Object,
                required: true,
            },
            minDurationParameter:{
                type: Number,
                required: true,
            },
            universe:{
                type: Object,
                default: null,
            },
            channelModificationRequest:{
                type: Object,
                default: null,
            },
            broadcastRight: {
                type: Array,
                required: true,
            },
        },
        data(){
            return {
                loading: false,
                isWatchingStatus:false,
                stopChannelTimeoutId: null,
                runningChannelModificationRequest: null,
                confirmChannelDeletionValue: '',
                dialogVisible: false,
                videoSource: null,
            };
        },
        computed: {
            ...mapGetters([
                'userIsAtLeastAdmin',
                'userIsEntityAdmin'
            ]),
            entityUid(){
                return this.channel.scopes.entity_uid;
            },
            videoSourceMainDetails(){
                if(this.videoSource)
                    return `${this.videoSource.type.toLowerCase()}://${this.videoSource.multicast_network_ip_main}:${this.videoSource.port_main}@${this.videoSource.multicast_network_src_main}`;
            },
            videoSourceBackupDetails(){
                if(this.videoSource)
                    return `${this.videoSource.type.toLowerCase()}://${this.videoSource.multicast_network_ip_backup}:${this.videoSource.port_backup}@${this.videoSource.multicast_network_src_backup}`;
            },
            channelBroadcastRights(){
                return this.broadcastRight.filter(
                    br => br.channel_uid === this.channel.uid
                );
            },
            disableEditInputButton(){
                if (!this.channel.confirmed || !['RUNNING','STOPPED'].includes(this.channel.status)){
                    return true;
                }
            },
            disableEditTimesButton(){
                if (!this.channel.confirmed){
                    return true;
                }
            },
            disableConfirmButton (){
                if (this.channel.confirmed){
                    return true;
                }
                return false;
            },
            disableStopButton(){
                if(!this.channel.confirmed || this.channel.status !== 'RUNNING'){
                    return true;
                }
                return false;
            },
            disableDeleteButton(){
                if(this.channelBroadcastRights.length > 0){
                    return true;
                }
                return false;
            },
            showEditButton(){
                if(
                    (this.userIsAtLeastAdmin || this.userIsEntityAdmin(this.entityUid))
                    && this.channel.status !== 'FINISHED'
                ){
                    return true;
                }
                return false;
            },
            showStopButton(){
                if(this.channel.status === 'FINISHED'){
                    return false;
                }
                return true;
            },
            showDeleteButton(){
                if(this.channel.confirmed && !['RUNNING','STOPPED'].includes(this.channel.status)){
                    return false;
                }
                return true;
            },
            defaultDuration(){
                let start = moment(this.channel.default_start_time, 'HH:mm:ss');
                let end = moment(this.channel.default_end_time, 'HH:mm:ss');
                // let start = moment('17:00:00', 'HH:mm:ss');
                // let end = moment('17:00:00', 'HH:mm:ss');
                return moment(end.diff(start)).subtract(1, 'hours').format('HH:mm:ss');
            },
            startTimeUTC (){
                return  moment.utc(this.channel.default_start_time, 'HH:mm').format('HH:mm');
            },
            startTimeLocal (){
                return  moment.utc(this.channel.default_start_time, 'HH:mm').local().format('HH:mm');
            },
            endTimeUtc (){
                return  moment.utc(this.channel.default_end_time, 'HH:mm').format('HH:mm');
            },
            endTimeLocal (){
                return  moment.utc(this.channel.default_end_time, 'HH:mm').local().format('HH:mm');
            },
            checkChannelDeletionConfirmation(){
                if(this.confirmChannelDeletionValue.toLowerCase() === this.channel.display_name.toLowerCase()){
                    return false;
                }
                return true;
            }
        },
        mounted(){
            if(
                this.channel.confirmed
                && (this.userIsAtLeastAdmin || this.userIsEntityAdmin(this.entityUid))
            ){
                this.getVideoSourceDetails(this.channel.video_source_uid)
            }
            if(this.channelModificationRequest){
                this.runningChannelModificationRequest = this.channelModificationRequest;
            }
            if(this.runningChannelModificationRequest && !this.isWatchingStatus){
                this.loading = true;
                this.watchChannelModificationRequest(this.runningChannelModificationRequest.url);
            }
        },
        methods:{
            getVideoSourceDetails(uid){
                this.$store.dispatch('remoteGet',{
                    url: `video-source/?uid=${uid}`
                })
                .then(res=>{
                    this.$set(this,'videoSource', res.data.results[0]);
                });
            },
            confirmChannel(){
                this.$refs['modal-confirm-channel'].confirmation = true;
                this.$refs['modal-confirm-channel'].open(this.channel, this.event);
            },
            editOtherFields(){
                this.$refs['modal-confirm-channel'].editingOtherFields = true;
                this.$refs['modal-confirm-channel'].open(this.channel, this.event);
            },
            editTimeFields(){
                this.$refs['modal-confirm-channel'].editingTimeFields = true;
                this.$refs['modal-confirm-channel'].open(this.channel, this.event);
            },
            editChannel(){
                this.$emit('on-update-channel');
            },
            onTriggerRefresh (){
                this.$emit('on-trigger-refresh');
            },
            hidePopoverStopChannel() {
                if (this.$refs['popover-stop-channel']) {
                    this.$refs['popover-stop-channel'].showPopper = false;
                }
            },
            stopChannel (){
                this.hidePopoverStopChannel();
                this.loading = true;
                this.$store.dispatch('createItem', {
                    item: {
                        action: 'STOP',
                        channel_uid: this.channel.uid,
                    },
                    scopes: {'X-Entity-Uid': this.channel.scopes.entity_uid},
                    model: 'channelModificationRequests',
                    url: this.$store.state.api.meta.listModels.channelModificationRequests.url
                }).then((res) => {
                    this.watchChannelModificationRequest(res.url);
                });
            },
            hideDeleteModal() {
                this.dialogVisible = false;
            },
            deleteChannel() {
                if(this.channel.confirmed){
                    this.hideDeleteModal();
                    this.loading = true;
                    this.$store.dispatch('createItem', {
                        item: {
                            action: 'DELETE',
                            channel_uid: this.channel.uid,
                        },
                        scopes: {'X-Entity-Uid': this.channel.scopes.entity_uid},
                        model: 'channelModificationRequests',
                        url: this.$store.state.api.meta.listModels.channelModificationRequests.url
                    }).then((res) => {
                        this.watchChannelModificationRequest(res.url);
                    });
                }else if (!this.channel.confirmed){
                    this.$store.dispatch('patchItem', {
                        item: {
                            uid: this.channel.uid,
                            url: this.channel.url,
                            archived: true,
                        },
                        model: 'channels'
                    }).then(() => {
                        this.$message.success({
                            message: 'The channel has been archived'
                        });
                        this.$emit('un-select-channel');
                    }).catch(() => {
                        this.$message.error({
                            message: 'The channel couldn\'t be archived'
                        });
                    });
                }
            },
            watchChannelModificationRequest(requestUrl){
                this.loading = true;
                this.isWatchingStatus = true;
                clearTimeout(this.stopChannelTimeoutId);
                this.$store.dispatch('remoteGet', {
                    url: requestUrl
                }).then(res => {
                    if (res.data && ['COMPLETED'].includes(res.data.status)) {
                        if (res.data.action === 'STOP') {
                            this.$message({
                                message: `Channel ${this.channel.display_name} successfully stopped!`,
                                type: 'success'
                            });
                            this.loading = false;
                            this.isWatchingStatus = false;
                            this.$emit('on-channel-stopped');
                        } else if ( res.data.action === 'UPDATE_INPUT'){
                            this.$message({
                                type: 'success',
                                message: `Channel ${this.channel.display_name} input updated`
                            });
                            this.loading = false;
                            this.isWatchingStatus = false;
                        }else if(res.data.action === 'DELETE'){
                            this.loading = false;
                            this.isWatchingStatus = false;
                            this.$emit('un-select-channel');
                        }
                    }
                    else if (res.data && ['FAILED'].includes(res.data.status)) {
                        console.error(res.data.verbose_status);
                        if (res.data.action === 'STOP') {
                            this.$message.error(`Error on stop channel ${this.channel.display_name}`);
                        } else if (res.data.action === 'UPDATE_INPUT') {
                            this.$message.error(`Error on updating ${this.channel.display_name} input`);
                        }else if(res.data.action === 'DELETE'){
                            this.$message.error(`Unable to delete ${this.channel.display_name} input`);
                        }
                        this.loading = false;
                        this.$set(this, 'runningChannelModificationRequest', null);
                        this.isWatchingStatus = false;
                    } else {
                        this.stopChannelTimeoutId = setTimeout(() => {
                            this.watchChannelModificationRequest(requestUrl);
                        }, 3000);
                    }
                });
            },
        }
    };
</script>


<style lang="css" scoped>
.channels-details{
    margin-top: 3em;
}

.gcmcn-danger-btn{
    margin: 0;
}

.channel-details-button{
    margin-bottom: 10px;
    width: 233px;
    justify-content: space-between;
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
}

.padding-left{
    margin-left: 10px;
}

.el-button{
    margin: 0
}

.actions{
    display: flex;
    justify-content: flex-end;
}
.confirmed-channel-deletion{
    background-color: #E6A23C;
    color: #FFF;
    padding: 2rem;
    margin: 2rem;
    border-radius: 5px;
}
.confirm-input{
    margin-top: 1rem;
}
</style>
<style>
    /*Style for element ui modal*/
    .modal-confirm-channel-deletion.el-dialog{
        color: #BBBBBB;
        font-size: 14px;
        word-break: break-all;
        background: linear-gradient(180deg, #111111 12.5%, #222222 100%) !important;
        -webkit-box-shadow: 0px 4px 4px rgb(0 0 0 / 25%) !important;
        box-shadow: 0px 4px 4px rgb(0 0 0 / 25%) !important;
        border-radius: 5px !important;
        text-transform: uppercase;
    }
    .modal-confirm-channel-deletion .el-dialog__title{
        color: #BBBBBB;
    }
    .modal-confirm-channel-deletion .validate-btn.el-button{
        color: white;
        margin-left: 10px;
        padding:  1rem !important;
        line-height: 0 !important;
        background-color: #00a3ff !important;
        border:  none !important;
    }
    .modal-confirm-channel-deletion .decline.el-button{
        padding:  1rem !important;
        line-height: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/channels-details.vue